import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Chart } from "primereact/chart";
import ProjectModals from "../../../core/modals/projectModal";
import RequestModals from "../../../core/modals/requestModal";
import TodoModal from "../../../core/modals/todoModal";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { fetchDashboardStats, fetchEmployeeDetails, fetchEmployeeLeaveToday, fetchEmployeesWithBirthdayToday } from "../../../core/data/redux/dashboards/admindashboard/adminDashboardActions";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { fetchTasks } from "../../../core/data/redux/projects/task/taskActions";
import { getEmployeeAttendanceByDate, getPunchByDate } from "../../../core/data/redux/attendance/punch/punchAction";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { fetchAllAssets } from "../../../core/data/redux/asset/asset/assetActions";
import { formatDate } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { getBirthdayByDate } from "../../../core/data/redux/calendar/calendarAction";
import { fetchProjectByDetails } from "../../../core/data/redux/projects/project/projectAction";
import { filterByStatus } from "../../../core/utils/filterActiveData";

interface Task {
  Status: string;
}

interface TaskStatsProps {
  tasks: Task[];
}


const AdminDashboard = () => {
  const routes = all_routes;
  const dispatch = useDispatch<AppDispatch>();
  const { stats } = useSelector((state: any) => state.dashboard.adminDashboard);
  const { employees, leavetoday } = useSelector((state: any) => state.dashboard.adminDashboard);
  const { birthdayEmployees } = useSelector((state: any) => state.dashboard.adminDashboard);
  const { projectsData } = useSelector((state: any) => state.project.projects);
  const { tasks } = useSelector((state: any) => state.project.task);
  const { punchesByDate } = useSelector((state: any) => state.attendance.punch);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedAttendanceDate, setSelectedAttendanceDate] = useState(dayjs().format("YYYY-MM-DD"));
  const { assets } = useSelector((state: any) => state.asset.newAsset);
  const [birthday, setbirthday] = useState<any>([]);
  const { employeeAttendanceAnalytics } = useSelector((state: any) => state.attendance.punch);
  const absentEmployees = employeeAttendanceAnalytics?.data?.filter((emp: any) => emp.AttendanceStatus === "Absent").slice(0, 6) || [];
  const totalAbsentCount = employeeAttendanceAnalytics?.data?.filter((emp: any) => emp.AttendanceStatus === "Absent")?.length || 0;
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const [projectDetails, setprojectDetails] = useState<any>([]);
  const [projectStats, setProjectStats] = useState<any>(null);
  const projectDATA2 = filterByStatus(projectsData, 'active', 'status');
  const [filterType, setFilterType] = useState("Absent"); // Absent | WeeklyOff

  const allEmployees = employeeAttendanceAnalytics?.data || [];
  const weeklyOffList = employeeAttendanceAnalytics?.weeklyOffAbsentList || [];

  // REMOVE weekly-off employees from absent list
  const absentEmployeess = allEmployees.filter(
    (emp: any) =>
      emp.AttendanceStatus === "Absent" &&
      (!emp.WeeklyOffId || emp.WeeklyOffId === null || emp.WeeklyOffId === 0)
  );

  const weeklyOffEmployees = weeklyOffList;

  const filteredList = filterType === "Absent" ? absentEmployees : weeklyOffEmployees;

  const totalCount =
    filterType === "Absent"
      ? absentEmployees.length
      : weeklyOffEmployees.length;


  useEffect(() => {
    if (projectsData.length > 0 && selectedProjectId === null) {
      setSelectedProjectId(projectsData[0].project_id);
    }
  }, [projectsData, selectedProjectId]);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const projectId = Number(event.target.value);
    setSelectedProjectId(projectId);
  };

  useEffect(() => {
    const formattedDate = selectedDate.toISOString().split('T')[0];
    dispatch(getPunchByDate(formattedDate));
  }, [dispatch, selectedDate]);

  const handleDateChange = (date: any) => {
    setSelectedDate(date);
  };

  const handleAttendanceDateChange = (value: any) => {
    if (value) {
      const formattedDate: any = dayjs(value).format("YYYY-MM-DD");
      setSelectedAttendanceDate(formattedDate);
    }
  };
  const getModalContainer = () =>
    document.getElementById("modal-datepicker") || document.body;

  const disableFutureDates = (current: dayjs.Dayjs) => {
    return current && current > dayjs().endOf("day");
  };

  useEffect(() => {
    if (!selectedProjectId) return;

    dispatch(fetchProjectByDetails({ projectId: selectedProjectId }))
      .then((res) => {
        setprojectDetails(res?.payload?.data);
        setProjectStats(res?.payload?.data);
      });
  }, [selectedProjectId, dispatch]);



  useEffect(() => {
    dispatch(getEmployeeAttendanceByDate(selectedAttendanceDate));
  }, [dispatch, selectedAttendanceDate]);

  useEffect(() => {
    if (!assets.length) {
      dispatch(fetchAllAssets());
    }
  }, [dispatch]);


  useEffect(() => {
    dispatch(fetchDashboardStats());
    function getTodayMonthDay() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${month}-${day}`;
    }

    const todayMMDD = getTodayMonthDay();
    dispatch(getBirthdayByDate(todayMMDD)).then((res) => {
      setbirthday(res.payload.data);
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchEmployeesWithBirthdayToday());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchEmployeeDetails());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchTasks());
    dispatch(fetchEmployeeLeaveToday())
  }, [dispatch]);


  const [date, setDate] = useState(new Date());
  const { users } = useSelector((state: any) => state.user);

  const userInformation = users?.[0]?.data;

  //New Chart
  const [empDepartment, setEmpDepartment] = useState<any>({
    chart: {
      height: 235,
      type: 'bar',
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      toolbar: {
        show: false,
      }
    },
    fill: {
      colors: ['#F26522'],
      opacity: 1,
    },
    colors: ['#F26522'],
    grid: {
      borderColor: '#E5E7EB',
      strokeDashArray: 5,
      padding: {
        top: -20,
        left: 0,
        right: 0,
        bottom: 0
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: true,
        barHeight: '35%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    series: [{
      data: [],
      name: 'Employee'
    }],
    xaxis: {
      categories: [],
      labels: {
        style: {
          colors: '#111827',
          fontSize: '13px',
        }
      }
    }
  });

  useEffect(() => {
    const departmentCount = employees.reduce((acc: any, employee: any) => {
      const department = employee.DepartmentName;
      acc[department] = (acc[department] || 0) + 1;
      return acc;
    }, {});

    const departments = Object.keys(departmentCount);
    const counts = Object.values(departmentCount);


    setEmpDepartment((prevState: any) => ({
      ...prevState,
      series: [{
        data: counts,
        name: 'Employee'
      }],
      xaxis: {
        categories: departments.map((dept) => (dept === 'null' || dept === null) ? 'None' : dept)
      }
    }));
  }, [employees]);


  const [salesIncome] = useState<any>({
    chart: {
      height: 290,
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false,
      }
    },
    colors: ['#FF6F28', '#F8F9FA'],
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0
        }
      }
    }],
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusWhenStacked: 'all',
        horizontal: false,
        endingShape: 'rounded'
      },
    },
    series: [{
      name: 'Income',
      data: [40, 30, 45, 80, 85, 90, 80, 80, 80, 85, 20, 80]
    }, {
      name: 'Expenses',
      data: [60, 70, 55, 20, 15, 10, 20, 20, 20, 15, 80, 20]
    }],
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    yaxis: {
      labels: {
        offsetX: -15,
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    grid: {
      borderColor: '#E5E7EB',
      strokeDashArray: 5,
      padding: {
        left: -8,
      },
    },
    legend: {
      show: false
    },
    dataLabels: {
      enabled: false // Disable data labels
    },
    fill: {
      opacity: 1
    },
  })

  //Attendance ChartJs
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  useEffect(() => {
    if (!employeeAttendanceAnalytics?.analytics) return;

    const { totalPresent, totalAbsent } = employeeAttendanceAnalytics.analytics;
    const data = {
      labels: ['Present', 'Absent'],
      datasets: [
        {
          label: 'Attendance',
          data: [totalPresent, totalAbsent],
          backgroundColor: ['#03C95A', '#E70D0D'],
          borderWidth: 5,
          borderRadius: 10,
          borderColor: '#fff', // Border between segments
          hoverBorderWidth: 0,   // Border radius for curved edges
          cutout: '60%',
        }
      ]
    };
    const options = {
      rotation: -100,
      circumference: 200,
      layout: {
        padding: {
          top: -20,    // Set to 0 to remove top padding
          bottom: -20, // Set to 0 to remove bottom padding
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false // Hide the legend
        }
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [employeeAttendanceAnalytics]);

  const [semidonutData, setSemidonutData] = useState({});
  const [semidonutOptions, setSemidonutOptions] = useState({});
  const [taskPercentages, setTaskPercentages] = useState({
    ongoingPercentage: 0,
    completedPercentage: 0,
    onHoldPercentage: 0,
    overduePercentage: 0,
  });

  useEffect(() => {
    const chartData = {
      labels: ["Total Tasks"],
      datasets: [
        {
          label: "Tasks",
          data: [Number(projectStats?.[0].TotalTaskCount || 0)],
          backgroundColor: ["#03700aff"],
          borderWidth: 5,
          borderRadius: 10,
          borderColor: "#fff",
          hoverBorderWidth: 0,
          cutout: "60%",
        },
      ],
    };

    const chartOptions = {
      rotation: -100,
      circumference: 200,
      layout: {
        padding: {
          top: -20,
          bottom: -20,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    };

    setSemidonutData(chartData);
    setSemidonutOptions(chartOptions);
  }, [selectedProjectId, projectStats]);


  const config = useAppConfig();
  if (!config) return null

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Admin Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admin Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Welcome Wrap */}
          <div className="card border-0">
            <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
              <div className="d-flex align-items-center mb-3">
                <span className="avatar avatar-xl flex-shrink-0">
                  <img src={userInformation?.image_path ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} className="rounded-circle" alt="img" />
                </span>
                <div className="ms-3">
                  <h3 className="mb-2">
                    Welcome Back, {userInformation?.DisplayName}{" "}
                    {/* <Link to="#" className="edit-icon">
                      <i className="ti ti-edit fs-14" />
                    </Link> */}
                  </h3>
                  {/* <p>
                    You have{" "}
                    <span className="text-primary text-decoration-underline">
                      21
                    </span>{" "}
                    Pending Approvals &amp;{" "}
                    <span className="text-primary text-decoration-underline">
                      14
                    </span>{" "}
                    Leave Requests
                  </p> */}
                </div>
              </div>
              {/* <div className="d-flex align-items-center flex-wrap mb-1">
                <Link
                  to="#"
                  className="btn btn-secondary btn-md me-2 mb-2"
                  data-bs-toggle="modal" data-inert={true}
                  data-bs-target="#add_project"
                >
                  <i className="ti ti-square-rounded-plus me-1" />
                  Add Project
                </Link>
                <Link
                  to="#"
                  className="btn btn-primary btn-md mb-2"
                  data-bs-toggle="modal" data-inert={true}
                  data-bs-target="#add_leaves"
                >
                  <i className="ti ti-square-rounded-plus me-1" />
                  Add Requests
                </Link>
              </div> */}
            </div>
          </div>
          {/* /Welcome Wrap */}
          <div className="row">
            {/* Widget Info */}
            <div className="col-xxl-8 d-flex">
              <div className="row flex-fill">
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-primary mb-2">
                        <i className="ti ti-calendar-share fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        Attendance
                      </h6>
                      <h3 className="mb-3">
                        {stats?.employeeAttendance?.present_employees_today}/{stats?.employeeAttendance?.total_active_employees}{" "}
                        {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-up me-1" />
                          +2.1%
                        </span> */}
                      </h3>
                      {/* <Link to={all_routes.attendanceemployee} className="link-default">
                        View Details
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-secondary mb-2">
                        <i className="ti ti-browser fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        Total Project's
                      </h6>
                      <h3 className="mb-3">
                        {stats?.projects?.active_projects}/{stats?.projects?.total_projects}{" "}
                        {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -2.1%
                        </span> */}
                      </h3>
                      {/* <Link to={all_routes.projectlist}  className="link-default">
                        View All
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-info mb-2">
                        <i className="ti ti-users-group fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        Total Clients
                      </h6>
                      <h3 className="mb-3">
                        {stats?.clients?.active_clients}/{stats?.clients?.total_clients}{" "}
                        {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -11.2%
                        </span> */}
                      </h3>
                      {/* <Link to={all_routes.clientlist} className="link-default">
                        View All
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="avatar rounded-circle bg-pink mb-2">
                        <i className="ti ti-checklist fs-16" />
                      </span>
                      <h6 className="fs-13 fw-medium text-default mb-1">
                        Total Tasks
                      </h6>
                      <h3 className="mb-3">
                        {stats?.tasks?.pending_tasks}/{stats?.tasks?.total_tasks}{" "}
                      </h3>

                    </div>
                  </div>
                </div>

              </div>
            </div>
            {/* /Widget Info */}
            {/* Employees By Department */}
            <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Employees By Department</h5>
                </div>
                <div className="card-body">
                  <ReactApexChart
                    id="emp-department"
                    options={empDepartment}
                    series={empDepartment.series}
                    type="bar"
                    height={220}
                  />

                </div>
              </div>
            </div>
            {/* /Employees By Department */}
          </div>
          <div className="row">
            {/* Total Employee */}
            <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Employee Status</h5>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <p className="fs-13 mb-3">Total Employee</p>
                    <h3 className="mb-3">{stats?.employeeAttendance?.total_active_employees}</h3>
                  </div>

                  {/* Dynamic Progress Bars */}
                  <div className="progress-stacked emp-stack mb-3">
                    {[
                      { label: 'Full-time', count: stats?.employeeAttendance?.full_time_employees, color: 'bg-primary' },
                      { label: 'Part-time', count: stats?.employeeAttendance?.part_time_employees, color: 'bg-secondary' },
                      { label: 'Contract', count: stats?.employeeAttendance?.contract_employees, color: 'bg-danger' },
                      { label: 'Freelance', count: stats?.employeeAttendance?.freelance_employees, color: 'bg-warning' },
                      { label: 'Internship', count: stats?.employeeAttendance?.internship_employees, color: 'bg-info' },
                      { label: 'Office', count: stats?.employeeAttendance?.office_employees, color: 'bg-success' },
                      { label: 'Client-side', count: stats?.employeeAttendance?.client_side_employees, color: 'bg-purple' },
                      { label: 'Remote', count: stats?.employeeAttendance?.remote_employees, color: 'bg-pink' }
                    ].map((category, index) => (
                      <div key={index} className="progress" role="progressbar" aria-label={category.label}
                        aria-valuenow={category.count}
                        aria-valuemin={0}
                        aria-valuemax={stats?.employeeAttendance?.total_active_employees}
                        style={{ width: `${(category.count / stats?.employeeAttendance?.total_active_employees) * 100}%` }}>
                        <div className={`progress-bar ${category.color}`} />
                      </div>
                    ))}
                  </div>

                  {/* Statistics for each Category */}
                  <div className="border mb-3">
                    <div className="row gx-0">
                      {[
                        { label: 'Full-time', count: stats?.employeeAttendance?.full_time_employees, color: 'text-primary' },
                        { label: 'Part-time', count: stats?.employeeAttendance?.part_time_employees, color: 'text-secondary' },
                        { label: 'Contract', count: stats?.employeeAttendance?.contract_employees, color: 'text-danger' },
                        { label: 'Freelance', count: stats?.employeeAttendance?.freelance_employees, color: 'text-warning' },
                        { label: 'Internship', count: stats?.employeeAttendance?.internship_employees, color: 'text-info' },
                        { label: 'Office', count: stats?.employeeAttendance?.office_employees, color: 'text-success' },
                        { label: 'Client-side', count: stats?.employeeAttendance?.client_side_employees, color: 'text-purple' },
                        { label: 'Remote', count: stats?.employeeAttendance?.remote_employees, color: 'text-pink' }
                      ].map((category, index) => (
                        <div key={index} className="col-6">
                          <div className={`p-2 flex-fill ${index > 3 ? '' : 'border-end'} ${index > 3 ? '' : 'border-bottom'}`}>
                            <p className="fs-13 mb-2">
                              <i className={`ti ti-square-filled ${category.color} fs-12 me-2`} />
                              {category.label} <span className="text-gray-9">
                                ({Math.round((category.count / stats?.employeeAttendance?.total_active_employees) * 100)}%)
                              </span>
                            </p>
                            <h2 className="display-1">{category.count}</h2>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <Link to={routes.employeeList} className="btn btn-light btn-md w-100">
                    View All Employees
                  </Link>
                </div>
              </div>
            </div>

            {/* /Total Employee */}

            {/* /Attendance Overview */}
            {/* Clock-In/Out */}
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">

                {/* ---------- HEADER ---------- */}
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">

                  <h5 className="mb-2">
                    {filterType === "Absent"
                      ? `Total Absenties (${totalCount})`
                      : `Total Weekly Off (${totalCount})`}
                  </h5>

                  <div className="d-flex align-items-center gap-2">

                    {/* ------- FILTER DROPDOWN -------- */}
                    <select
                      className="form-select me-2"
                      style={{ width: "150px" }}
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="Absent">Absent</option>
                      <option value="WeeklyOff">Weekly Off</option>
                    </select>

                    {/* ------- DATE PICKER -------- */}
                    <DatePicker
                      className="form-control border-0 ps-4 bg-primary text-white shadow-none"
                      format={{ format: "DD-MM-YYYY", type: "mask" }}
                      getPopupContainer={getModalContainer}
                      placeholder="DD-MM-YYYY"
                      onChange={handleAttendanceDateChange}
                      disabledDate={disableFutureDates}
                      value={dayjs(selectedAttendanceDate)}
                      style={{ width: "150px" }}
                    />
                  </div>
                </div>

                {/* ---------- BODY ---------- */}
                <div className="card-body">

                  {filteredList.length > 0 ? (
                    filteredList.map((emp: any, index: number) => (
                      <div
                        key={`${emp.EmployeeID}-${index}`}
                        className="d-flex align-items-center justify-content-between mb-3 p-2 border br-5"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              emp.PictureURL ||
                              "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                            }
                            alt="employee"
                            className="avatar flex-shrink-0 rounded-circle"
                          />
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium">{emp.Name}</h6>
                            <p
                              className="fs-13"
                              style={{
                                color: filterType === "Absent" ? "red" : "green",
                                marginBottom: 0,
                              }}
                            >
                              {filterType === "Absent" ? "Absent" : "Weekly Off"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">
                      {filterType === "Absent"
                        ? "No absent employees on this date."
                        : "No weekly-off employees today."}
                    </p>
                  )}

                </div>

              </div>
            </div>
            {/* /Clock-In/Out */}


            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Employees on Leave</h5>
                  <Link to={routes.leaveadmin} className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Mode</th>
                        </tr>
                      </thead>

                      <tbody>
                        {leavetoday && leavetoday.length > 0 ? (
                          leavetoday.map((item: any) => (
                            <tr key={item.LeaveRequestId}>
                              <td className="font-semibold">{item.Name}</td>
                              <td className="text-gray-500 text-sm">{item.LeaveMode}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} className="text-center py-3">
                              No employees on leave today
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="row">
            {/* Jobs Applicants */}
            {/* <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Jobs Applicants</h5>
                  <Link to="job-list.html" className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <ul
                    className="nav nav-tabs tab-style-1 nav-justified d-sm-flex d-block p-0 mb-4"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <Link
                        className="nav-link fw-medium"
                        data-bs-toggle="tab"
                        data-bs-target="#openings"
                        aria-current="page"
                        to="#openings"
                        aria-selected="true"
                        role="tab"
                      >
                        Openings
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        className="nav-link fw-medium active"
                        data-bs-toggle="tab"
                        data-bs-target="#applicants"
                        to="#applicants"
                        aria-selected="false"
                        tabIndex={-1}
                        role="tab"
                      >
                        Applicants
                      </Link>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane fade" id="openings">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0 bg-gray-100"
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/apple.svg"
                              className="img-fluid rounded-circle w-auto h-auto"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Senior IOS Developer</Link>
                            </p>
                            <span className="fs-12">No of Openings : 25 </span>
                          </div>
                        </div>
                        <Link to="#"
                          className="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                        >
                          <i className="ti ti-edit" />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0 bg-gray-100"
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/php.svg"
                              className="img-fluid w-auto h-auto"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Junior PHP Developer</Link>
                            </p>
                            <span className="fs-12">No of Openings : 20 </span>
                          </div>
                        </div>
                        <Link to="#"
                          className="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                        >
                          <i className="ti ti-edit" />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0 bg-gray-100"
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/react.svg"
                              className="img-fluid w-auto h-auto"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">
                                Junior React Developer{" "}
                              </Link>
                            </p>
                            <span className="fs-12">No of Openings : 30 </span>
                          </div>
                        </div>
                        <Link to="#"
                          className="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                        >
                          <i className="ti ti-edit" />
                        </Link>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-0">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0 bg-gray-100"
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/laravel-icon.svg"
                              className="img-fluid w-auto h-auto"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">
                                Senior Laravel Developer
                              </Link>
                            </p>
                            <span className="fs-12">No of Openings : 40 </span>
                          </div>
                        </div>
                        <Link to="#"
                          className="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                        >
                          <i className="ti ti-edit" />
                        </Link>
                      </div>
                    </div>
                    <div className="tab-pane fade show active" id="applicants">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0"
                          >
                            <ImageWithBasePath
                              src="assets/img/users/user-09.jpg"
                              className="img-fluid rounded-circle"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Brian Villalobos</Link>
                            </p>
                            <span className="fs-13 d-inline-flex align-items-center">
                              Exp : 5+ Years
                              <i className="ti ti-circle-filled fs-4 mx-2 text-primary" />
                              USA
                            </span>
                          </div>
                        </div>
                        <span className="badge badge-secondary badge-xs">
                          UI/UX Designer
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0"
                          >
                            <ImageWithBasePath
                              src="assets/img/users/user-32.jpg"
                              className="img-fluid rounded-circle"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Anthony Lewis</Link>
                            </p>
                            <span className="fs-13 d-inline-flex align-items-center">
                              Exp : 4+ Years
                              <i className="ti ti-circle-filled fs-4 mx-2 text-primary" />
                              USA
                            </span>
                          </div>
                        </div>
                        <span className="badge badge-info badge-xs">
                          Python Developer
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0"
                          >
                            <ImageWithBasePath
                              src="assets/img/users/user-32.jpg"
                              className="img-fluid rounded-circle"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Stephan Peralt</Link>
                            </p>
                            <span className="fs-13 d-inline-flex align-items-center">
                              Exp : 6+ Years
                              <i className="ti ti-circle-filled fs-4 mx-2 text-primary" />
                              USA
                            </span>
                          </div>
                        </div>
                        <span className="badge badge-pink badge-xs">
                          Android Developer
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-0">
                        <div className="d-flex align-items-center">
                          <Link to="#"
                            className="avatar overflow-hidden flex-shrink-0"
                          >
                            <ImageWithBasePath
                              src="assets/img/users/user-34.jpg"
                              className="img-fluid rounded-circle"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2 overflow-hidden">
                            <p className="text-dark fw-medium text-truncate mb-0">
                              <Link to="#">Doglas Martini</Link>
                            </p>
                            <span className="fs-13 d-inline-flex align-items-center">
                              Exp : 2+ Years
                              <i className="ti ti-circle-filled fs-4 mx-2 text-primary" />
                              USA
                            </span>
                          </div>
                        </div>
                        <span className="badge badge-purple badge-xs">
                          React Developer
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* /Jobs Applicants */}
            {/* Employees */}
            {/* Attendance Overview */}
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Attendance Overview</h5>
                </div>
                <div className="card-body">
                  <div className="chartjs-wrapper-demo position-relative mb-4">
                    <Chart type="doughnut" data={chartData} options={chartOptions} className="w-full attendence-chart md:w-30rem" />
                    <div className="position-absolute text-center attendance-canvas">
                      <p className="fs-13 mb-1">Total Attendance</p>
                      <h3>{employeeAttendanceAnalytics?.data?.length}</h3>
                    </div>
                  </div>
                  <h6 className="mb-3">Status</h6>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-success me-1" />
                      Present
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {employeeAttendanceAnalytics?.analytics?.totalPresent
                        ? `${Math.round(
                          (employeeAttendanceAnalytics.analytics.totalPresent /
                            employeeAttendanceAnalytics.analytics.totalEmployees) *
                          100
                        )}%`
                        : '0%'}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <p className="f-13 mb-2">
                      <i className="ti ti-circle-filled text-danger me-1" />
                      Absent
                    </p>
                    <p className="f-13 fw-medium text-gray-9 mb-2">
                      {employeeAttendanceAnalytics?.analytics?.totalAbsent
                        ? `${Math.round(
                          (employeeAttendanceAnalytics.analytics.totalAbsent /
                            employeeAttendanceAnalytics.analytics.totalEmployees) *
                          100
                        )}%`
                        : '0%'}
                    </p>

                  </div>
                  <div className="bg-light br-5 box-shadow-xs p-2 pb-0 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center">
                      <p className="mb-2 me-2">Total Absenties</p>
                      <div className="avatar-list-stacked avatar-group-sm mb-2">
                        {absentEmployees.map((emp: any, idx: number) => (
                          <span className="avatar avatar-rounded" key={`absent-${emp.EmployeeID}-${idx}`}>
                            <img
                              className="border border-white"
                              src={emp.PictureUR ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                              alt={emp.Name}
                              title={emp.Name}
                            />
                          </span>
                        ))}
                        {employeeAttendanceAnalytics?.analytics?.totalAbsent > 6 && (
                          <Link className="avatar bg-primary avatar-rounded text-fixed-white fs-10" to={all_routes.attendanceadmin}>
                            +{employeeAttendanceAnalytics.analytics.totalAbsent - 6}
                          </Link>
                        )}
                      </div>
                    </div>
                    <Link to={all_routes.attendanceadmin}
                      className="fs-13 link-primary text-decoration-underline mb-2"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Assets Overview</h5>
                  <Link to={routes.assetList} className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Asset Name</th>
                          <th>Available Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {assets?.slice(-5).reverse().map((asset: any) => (
                          <tr key={asset.assetId}>
                            <td>
                              <div className="d-flex align-items-center">
                                <Link to="#" className="avatar">
                                  <img
                                    src={asset.Images ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                    className="img-fluid rounded-circle"
                                    alt="asset-img"
                                    width="32"
                                    height="32"
                                  />
                                </Link>
                                <div className="ms-2">
                                  <h6 className="fw-medium mb-0">
                                    <Link to="#">{asset.AssetName}</Link>
                                  </h6>
                                  <span className="fs-12">{asset.BrandName}</span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className={`badge ${asset.availableAssetCount > 0 ? 'badge-success' : 'badge-danger'} badge-xs`}>
                                {asset.availableAssetCount}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* /Employees */}
            {/* Todo */}
            {/* <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Sales Overview</h5>
                  <div className="d-flex align-items-center">
                    <div className="dropdown mb-2">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-white border-0 btn-sm d-inline-flex align-items-center fs-13 me-2"
                        data-bs-toggle="dropdown"
                      >
                        All Departments
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link to="#"
                            className="dropdown-item rounded-1"
                          >
                            UI/UX Designer
                          </Link>
                        </li>
                        <li>
                          <Link to="#"
                            className="dropdown-item rounded-1"
                          >
                            HR Manager
                          </Link>
                        </li>
                        <li>
                          <Link to="#"
                            className="dropdown-item rounded-1"
                          >
                            Junior Tester
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-1">
                      <p className="fs-13 text-gray-9 me-3 mb-0">
                        <i className="ti ti-square-filled me-2 text-primary" />
                        Income
                      </p>
                      <p className="fs-13 text-gray-9 mb-0">
                        <i className="ti ti-square-filled me-2 text-gray-2" />
                        Expenses
                      </p>
                    </div>
                    <p className="fs-13 mb-1">Last Updated at 11:30PM</p>
                  </div>
                  <ReactApexChart
                    id="sales-income"
                    options={salesIncome}
                    series={salesIncome.series}
                    type="bar"
                    height={270}
                  />
                </div>
              </div>

            </div> */}
            {/* /Todo */}
          </div>

          <div className="row">
            {/* Projects */}
            <div className="col-xxl-8 col-xl-7 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Projects</h5>
                  <div className="d-flex align-items-center">
                    <Link to={routes.projectlist}>
                      Show All
                    </Link>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Team</th>
                          <th>Deadline</th>
                          <th>Priority</th>
                        </tr>
                      </thead>
                      <tbody>
                        {projectDATA2?.slice(-7).map((project: any) => (
                          <tr key={project.project_id}>
                            <td>
                              <div>{project.project_id}</div>
                            </td>
                            <td>
                              <h6 className="fw-medium">
                                <div>{project.project_name}</div>
                              </h6>
                            </td>
                            <td>
                              <div className="avatar-list-stacked avatar-group-sm">
                                {project.employee_names?.map((employeeName: string, index: number) => {
                                  const picture = project.employee_pictures?.[index];
                                  return (
                                    <span key={index} className="avatar avatar-rounded">
                                      {picture ? (
                                        <img
                                          className="border border-white"
                                          src={picture}
                                          alt={employeeName}
                                          title={employeeName}
                                        />
                                      ) : (
                                        <span
                                          className="avatar avatar-rounded border border-white bg-secondary text-white d-flex align-items-center justify-content-center p-1"
                                          title={employeeName}
                                        >
                                          NA
                                        </span>
                                      )}
                                    </span>
                                  );
                                })}
                                {project.employee_names?.length > 3 && (
                                  <Link
                                    className="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                                    to="#"
                                  >
                                    +{project.employee_names.length - 3}
                                  </Link>
                                )}
                              </div>
                            </td>
                            <td>{formatDate(project.end_date, config)}</td>
                            <td>
                              <span
                                className={`badge 
                                ${project.priority === "High" ? "badge-danger" : ""}
                                ${project.priority === "Medium" ? "badge-warning" : ""}
                                ${project.priority === "Low" ? "badge-success" : ""}`}
                              >
                                {project.priority}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* /Projects */}
            {/* Tasks Statistics */}

            <div className="col-xxl-4 col-xl-5 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between">
                  <h5 className="mb-0 d-flex align-items-center">Tasks Statistics</h5>

                  <select
                    id="projectSelect"
                    onChange={handleSelectChange}
                    value={selectedProjectId ?? ""}
                    className="px-3 py-2 border border-gray-300 rounded-lg shadow-sm 
      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
      text-gray-700 bg-white transition duration-200"
                  >
                    <option value="" disabled>
                      -- Choose a Project --
                    </option>
                    {projectDATA2.map((project: any, index: number) => (
                      <option key={`project-${project.project_id}-${index}`} value={project.project_id}>
                        {project.project_name}
                      </option>
                    ))}
                  </select>
                </div>


                <div className="card-body">
                  <div
                    className="chartjs-wrapper-demo position-relative mb-4"
                    style={{ height: "260px" }}
                  >
                    <Chart
                      type="doughnut"
                      data={semidonutData}
                      options={semidonutOptions}
                      className="w-100 attendence-chart"
                    />
                    <div className="position-absolute top-50 start-50 translate-middle text-center attendance-canvas">
                      <p className="fs-13 mb-1">Total Tasks</p>
                      <h3>
                        {projectDetails && projectDetails.length > 0
                          ? projectDetails[0].TotalTaskCount
                          : 0}
                      </h3>
                    </div>

                    <div className="d-flex flex-wrap justify-content-center gap-2 mt-2">
                      {projectDetails && projectDetails.length > 0 &&
                        projectDetails[0].TaskBoardNames?.map((taskBoard: any, index: any) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary px-3 py-2 shadow-sm"
                            style={{
                              fontSize: "12px",
                              background: "linear-gradient(90deg,#4e73df,#1cc88a)"
                            }}
                          >
                            {taskBoard.TaskBoardName} ({taskBoard.TaskCount})
                          </span>
                        ))}
                    </div>
                  </div>

                  {/* <div className="d-flex align-items-center flex-wrap justify-content-start">
                    <div className="border-end text-center me-3 pe-3 mb-3">
                      <p className="fs-13 d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-10 me-1 text-warning" />
                        Ongoing
                      </p>
                      <h5>{Math.round(taskPercentages.ongoingPercentage)}%</h5>
                    </div>

                    <div className="border-end text-center me-3 pe-3 mb-3">
                      <p className="fs-13 d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-10 me-1 text-info" />
                        On Hold
                      </p>
                      <h5>{Math.round(taskPercentages.onHoldPercentage)}%</h5>
                    </div>

                    <div className="border-end text-center me-3 pe-3 mb-3">
                      <p className="fs-13 d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-10 me-1 text-danger" />
                        Overdue
                      </p>
                      <h5>{Math.round(taskPercentages.overduePercentage)}%</h5>
                    </div>

                    <div className="text-center me-2 pe-2 mb-3">
                      <p className="fs-13 d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-10 me-1 text-success" />
                        Completed
                      </p>
                      <h5>
                        {Math.round(taskPercentages.completedPercentage)}%
                      </h5>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* /Tasks Statistics */}
          </div>
          <div className="row">
            {/* Schedules */}
            {/* <div className="col-xxl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Schedules</h5>
                  <Link to="candidates.html" className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <div className="bg-light p-3 br-5 mb-4">
                    <span className="badge badge-secondary badge-xs mb-1">
                      UI/ UX Designer
                    </span>
                    <h6 className="mb-2 text-truncate">
                      Interview Candidates - UI/UX Designer
                    </h6>
                    <div className="d-flex align-items-center flex-wrap">
                      <p className="fs-13 mb-1 me-2">
                        <i className="ti ti-calendar-event me-2" />
                        Thu, 15 Feb 2025
                      </p>
                      <p className="fs-13 mb-1">
                        <i className="ti ti-clock-hour-11 me-2" />
                        01:00 PM - 02:20 PM
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
                      <div className="avatar-list-stacked avatar-group-sm">
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-49.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-13.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-11.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-22.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-58.jpg"
                            alt="img"
                          />
                        </span>
                        <Link
                          className="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                          to="#"
                        >
                          +3
                        </Link>
                      </div>
                      <Link to="#" className="btn btn-primary btn-xs">
                        Join Meeting
                      </Link>
                    </div>
                  </div>
                  <div className="bg-light p-3 br-5 mb-0">
                    <span className="badge badge-dark badge-xs mb-1">
                      IOS Developer
                    </span>
                    <h6 className="mb-2 text-truncate">
                      Interview Candidates - IOS Developer
                    </h6>
                    <div className="d-flex align-items-center flex-wrap">
                      <p className="fs-13 mb-1 me-2">
                        <i className="ti ti-calendar-event me-2" />
                        Thu, 15 Feb 2025
                      </p>
                      <p className="fs-13 mb-1">
                        <i className="ti ti-clock-hour-11 me-2" />
                        02:00 PM - 04:20 PM
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
                      <div className="avatar-list-stacked avatar-group-sm">
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-49.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-13.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-11.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-22.jpg"
                            alt="img"
                          />
                        </span>
                        <span className="avatar avatar-rounded">
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/users/user-58.jpg"
                            alt="img"
                          />
                        </span>
                        <Link
                          className="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                          to="#"
                        >
                          +3
                        </Link>
                      </div>
                      <Link to="#" className="btn btn-primary btn-xs">
                        Join Meeting
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* /Schedules */}
            {/* Recent Activities */}
            {/* <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Recent Activities</h5>
                  <Link to="activity.html" className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-38.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">Matt Morgan</Link>
                            </h6>
                            <p className="fs-13">05:30 PM</p>
                          </div>
                          <p className="fs-13">
                            Added New Project{" "}
                            <span className="text-primary">HRMS Dashboard</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-01.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">Jay Ze</Link>
                            </h6>
                            <p className="fs-13">05:00 PM</p>
                          </div>
                          <p className="fs-13">Commented on Uploaded Document</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-19.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">Mary Donald</Link>
                            </h6>
                            <p className="fs-13">05:30 PM</p>
                          </div>
                          <p className="fs-13">Approved Task Projects</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-11.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">George David</Link>
                            </h6>
                            <p className="fs-13">06:00 PM</p>
                          </div>
                          <p className="fs-13">
                            Requesting Access to Module Tickets
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-20.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">Aaron Zeen</Link>
                            </h6>
                            <p className="fs-13">06:30 PM</p>
                          </div>
                          <p className="fs-13">Downloaded App Reportss</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-item">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center w-100">
                        <Link to="#"
                          className="avatar  flex-shrink-0"
                        >
                          <ImageWithBasePath
                            src="assets/img/users/user-08.jpg"
                            className="rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2 flex-fill">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fs-medium text-truncate">
                              <Link to="#">Hendry Daniel</Link>
                            </h6>
                            <p className="fs-13">05:30 PM</p>
                          </div>
                          <p className="fs-13">
                            Completed New Project <span>HMS</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* /Recent Activities */}

            <div className="row">
              {/* Birthdays */}
              <div className="col-xxl-6 col-xl-7 d-flex">
                <div className="card flex-fill">
                  <div className="card-header py-2 d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">Birthdays</h5>
                  </div>
                  <div className="card-body py-2">
                    <h6 className="mb-3 text-muted">Upcoming</h6>
                    {birthday?.map((employee: any, index: number) => (
                      <div key={`birthday-${employee.EmployeeID}-${index}`} className="bg-light p-2 border rounded mb-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <img
                              src={employee.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                              alt="avatar"
                              className="rounded-circle"
                              width="36"
                              height="36"
                            />
                            <div className="ms-2">
                              <h6 className="mb-0 fs-14">{employee.Name}</h6>
                              <small className="text-muted">{employee.DesignationName} | {employee.DepartmentName}</small>
                            </div>
                          </div>
                          <div className="text-end">
                            <div className="badge bg-secondary fs-12">
                              {new Date(employee.DateOfBirth).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short"
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>


              {/* /Birthdays */}
            </div>

          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      <ProjectModals />
      <RequestModals />
      <TodoModal />
    </>

  );
};

export default AdminDashboard;

